import React, { useEffect } from 'react';

import { getService } from 'react-in-angularjs';
import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { ActiveCalendarSchedule } from './ActiveCalendarSchedule/ActiveCalendarSchedule';
import { EditActiveCalendar } from './EditActiveCalendar/EditActiveCalendar';
import { useModalToggle } from '../../../../../shared/hooks/useModalToggle';
import { customerActiveCalendarStore } from '../../../../stores/customerActiveCalendarStore';

const NgzCustomerActiveCalendarTab = observer(() => {
  const [isShowEdit, showEditHandler] = useModalToggle();

  const $routeParams = getService('$routeParams');
  useEffect(() => customerActiveCalendarStore.setDefaultValues, []);

  return isShowEdit ? (
    <EditActiveCalendar showEditHandler={showEditHandler} customerId={$routeParams.id} />
  ) : (
    <ActiveCalendarSchedule
      showEditHandler={showEditHandler}
      customerId={$routeParams.id}
    />
  );
});

angularizeWithProviders(NgzCustomerActiveCalendarTab, 'ngzCustomerActiveCalendarTab', {});

export default NgzCustomerActiveCalendarTab;
